var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.875C0 0.84082 0.971615 0 2.16667 0H7.58333V3.75C7.58333 4.26855 8.06745 4.6875 8.66667 4.6875H13V13.125C13 14.1592 12.0284 15 10.8333 15H2.16667C0.971615 15 0 14.1592 0 13.125V1.875ZM13 3.75H8.66667V0L13 3.75Z",
    fill: "#373939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRange);
export default __webpack_public_path__ + "static/media/range.3d6d0e0e23b74170d22f971fafd25715.svg";
export { ForwardRef as ReactComponent };